import React from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  searchText: {
    fontFamily: 'Poppins',
    marginBottom: theme.spacing(2),
  },

  searchBold: {
    fontWeight: 800,
  },
}))

const HeaderSearchText = ({ searchParams }) => {
  const classes = useStyles()

  const renderSearchText = () => {
    const { estabelecimento, servico, servicoName, cidade } = searchParams

    if (estabelecimento || (servico && servico !== 'none') || cidade) {
      return (
        <span>
          Buscando{' '}
          {estabelecimento ? (
            <span>
              por <span className={classes.searchBold}>{estabelecimento}</span>
            </span>
          ) : (
            ''
          )}{' '}
          {servico && servico !== 'none' ? (
            <span>
              na seção <span className={classes.searchBold}>{servicoName}</span>
            </span>
          ) : (
            ''
          )}{' '}
          {cidade ? (
            <span>
              em <span className={classes.searchBold}>{cidade}</span>
            </span>
          ) : (
            ''
          )}
        </span>
      )
    }
  }

  return (
    <Grid item xs={12} className={classes.searchText}>
      <Typography variant='h4'>{renderSearchText()}</Typography>
    </Grid>
  )
}

export default HeaderSearchText
